// OfflineStrip (board today/board--offline): «غير متصل · آخر تحديث ٤:٤٠ م» +
// «تحديث». Writes on the screen are disabled while it shows (except the local
// queue's invoice/receipt drafts). Renders nothing while online.

import { CloudOff, RefreshCw } from 'lucide-react';
import { useSyncExternalStore } from 'react';
import { onlineStore } from '@/lib/online';
import { formatTime } from '@/lib/format';
import { Button } from './Button';

export interface OfflineStripProps {
  /** Epoch ms or ISO of the data on screen (the device's real «آخر تحديث»). */
  lastUpdatedAt?: number | string | null;
  onRefresh?: () => void;
  /** Force rendering regardless of connectivity (tests / previews). */
  offline?: boolean;
}

export function useOnline(): boolean {
  return useSyncExternalStore(onlineStore.subscribe, onlineStore.isOnline, onlineStore.isOnline);
}

export function OfflineStrip({ lastUpdatedAt, onRefresh, offline }: OfflineStripProps) {
  const online = useOnline();
  const isOffline = offline ?? !online;
  if (!isOffline) return null;
  return (
    <div className="e-offline" role="status">
      <CloudOff aria-hidden="true" />
      <span>
        غير متصل
        {lastUpdatedAt != null && <> · آخر تحديث {formatTime(lastUpdatedAt)}</>}
      </span>
      {onRefresh && (
        <Button size="sm" variant="ghost" icon={RefreshCw} onClick={onRefresh}>
          تحديث
        </Button>
      )}
    </div>
  );
}
